import React from 'react';
import { IconSuccess, IconWarning } from '@americanexpress/dls-icons';
import {
  Tooltip, TooltipButton, IconInfo,
} from '@americanexpress/dls-react';
import TextArea from './Element/TextArea';
import Input from './Element/Input';
import Select from './Element/Select';
import Checkbox from './Element/Checkbox';
import Currency from './Element/CurrencyInput';
import Button from './Element/Button';
import DlsAccordion from './Element/DlsAccordion';
import RadioButton from './Element/RadioButton';
import Modal from './Element/Modal';
import Image from './Element/Image';
import Camera from './Camera';
import CameraVideo from './CameraVideo';
import FileUpload from './Element/FileUpload';
import DateSelector from './Element/DateSelector';
import InputDate from './Element/InputDate';
import QrCode from './Element/Qrcode';
import QrWrapper from './Element/QrWrapper';
import Consent from './Element/consent';
import RequestLimit from './Element/RequestLimit';
import CardSelection from './Element/CardSelection';
import { parseHtml } from '../utils/util';
import MultiTracker from './Element/MultiTracker';
import HeroBanner from './Element/HeroBanner';
import P from './Element/Paragraph';
import Esign from './Element/Esign';
import Singpass from './Element/Singpass';
import CardPayment from './Element/CardPayment';
import MultiSelectComponent from './Element/MultiSelectComponent';
import IconWithLabel from './Element/IconWithLabel';
import Password from './Element/Password';
import StaticTable from './Element/StaticTable';
import CardDetails from './Element/CardDetails';
import DlsInput from './Element/DlsInput';
import DlsSelect from './Element/DlsSelect';
import ShowSubKeys from './Element/ShowSubmisisonKeysVal';
import PayloadFileAttachment from './Element/PayloadFileAttachment';
import PayloadFileAttachmentV2 from './Element/PayloadFileAttachmentV2';
import GroupedRedirectionAnchor from './Element/GroupedRedirectionAnchor';
import ReCaptcha from './Element/ReCaptcha';
import ApiButton from './Element/ApiButton';
import ExpandableTable from './Element/ExpandalbleTable';
import CopyLink from './Element/CopyLink';
import GroupCheckboxesMultiSelect from './Element/GroupCheckBoxMultiSelect';
import CreateQr from './Element/CreateQr';
import GroupedCheckboxes from './Element/GroupedCheckboxes';
/* eslint-disable  import/no-cycle -- need */
import PopUp from './Element/PopUp';
import Search from './Element/Search';
import Maps from './Element/Maps';
import Anchor from './Element/Anchor';
import Phone from './Element/PhoneInput';
import DynamicDlsAccordion from './Element/DynamicDlsAccordion';
import HeadingComponent from './Element/HeadingComponent';
import SuppCardComponent from './Element/SuppCardComponent';
import SuppCardDetails from './Element/SuppCardDetails';
import LeMappings from './Element/LeMapping';
import SplitInput from './Element/SplitInput';
import GroupedImageSelect from './Element/GroupedImageSelect';
import ActionableCard from './Element/ActionableCard';
import LeReconDoc from './Element/LeReconDoc';
import DlsCarousel from './Element/DlsCarousel';
import DlsDateRangePicker from './Element/DateRangePicker';
import DlsTab from './Element/DlsTab';
import List from './Element/List';

const findElement = (childProps, props) => {
  // props are static props here
  const {
    refreshForm,
    formSubmissionPayload,
    selectedMemberInfo,
    setUserConsentCheckboxValue,
    handleSubmit,
    getFileUploadInfo,
    setCurrencySymbol,
    handleOnChangeEvents,
    createFile,
    fileSubmit,
    apiResponse,
    setApiResponse,
    fileUploadInfo,
    handleBack,
    isSubmitButtonDisable,
    loggerApiCall,
    journeyId,
    setFormSubmissionPayload,
    isFormSubmission,
    handleContinue,
    filesToAttach,
    setFilesToAttach,
    setValidationErrors,
    validationErrors,
    setFocus,
    entityData,
    setEntityData,
    idsToClear,
    operationCaller,
    entityToEdit,
    setEntityId,
    s3FileInfo,
    setS3FileInfo,
    allS3FileIds,
    setAllS3FileIds,
    formPageType,
    disabledButtons,
    setDisabledButtons,
    setShowPopUp,
    showPopUp,
    setEvaluatePopUpId,
    curPageValues,
    setCurPageValues,
    formContainer,
    griffinFileInfo,
    setGriffinFileInfo,
    dispatchIdsState,
    comments,
    setComments,
    entityComments,
    entityCompositeKey,
    setEntityCompositeKey,
    objectOfFunctions,
    extractMapResponseValueByKey,
    setFileData,
    putDataToS3,
    s3EsignFileInfo,
    payloadFields,
    elementContainer,
    changePageValues,
    setChangePageValues,
    setS3EsignFileInfo,
    setIsFormSubmission,
    iformIntegrationUrls,
    dataObject,
    selectedOptions,
    setSelectedOptions,
    setSelectedOptionLabels,
    selectedOptionLabels,
  } = props;

  // childProps are coming from JSON
  const {
    fieldType,
    fieldLabel,
    fieldValue,
    cssProperties,
    fieldIndicator,
    fieldHref,
    customTag,
    fieldValidation,
    target = '_blank',
    // imgProps,
  } = childProps;

  /**
   * enable elements based on any selection
   * @param {*} args
   */
  const isEnableElements = (args) => {
    refreshForm(args);
  };

  /**
   * return element based on passed
   * field type
   * @param {*} fieldType
   */
  /* eslint complexity: ["error", 100] -- need to increase complexity */
  const elementSwitch = (type) => {
    switch (type) {
      case 'leMappings':
        return (
          <LeMappings
            childProps={childProps}
            props={props}
            filledFormData={formSubmissionPayload}
          />
        );
      case 'leReconDoc':
        return (
          <LeReconDoc
            {...childProps}
            props={props}
            formSubmissionPayload={formSubmissionPayload}
            entityData={entityData}
          />
        );
      case 'groupCheckboxesMultiSelect':
        return (
          <GroupCheckboxesMultiSelect
            {...childProps}
            formSubmissionPayload={formSubmissionPayload}
            setFormSubmissionPayload={setFormSubmissionPayload}
            formData={formSubmissionPayload}
            memberInfo={selectedMemberInfo}
            handleOnChangeEvents={handleOnChangeEvents}
          />
        );
      case 'qrWrapper':
        return (
          <QrWrapper
            {...childProps}
            formSubmissionPayload={formSubmissionPayload}
            setFormSubmissionPayload={setFormSubmissionPayload}
            memberInfo={selectedMemberInfo}
            handleOnChangeEvents={handleOnChangeEvents}
          />
        );
      case 'qrcode':
        return (<QrCode {...formSubmissionPayload} />);
      case 'heading':
        return (
          fieldIndicator
            ? (
              <HeadingComponent
                {...childProps}
                setFormSubmissionPayload={setFormSubmissionPayload}
                formSubmissionPayload={formSubmissionPayload}
              />
            ) : null
        );
      case 'a':
        return fieldIndicator ? <a className={cssProperties.style} href={fieldHref} target={target} rel="noreferrer">{parseHtml(fieldValue)}</a> : null;
      case 'p':
        return (
          fieldIndicator
            ? (
              <p className={cssProperties.style}>
                {parseHtml(fieldValue)}
                {fieldValidation
                  && fieldValidation.isToolTip
                  && (
                    <>
                      <span>{' '}</span>
                      <Tooltip id="ToolTip" className="col-md-6" triggerElement={<TooltipButton icon={<IconInfo size="sm" title="info" />} />}>{fieldValidation.toolTipInfo}</Tooltip>
                    </>
                  )}
              </p>
            )
            : null);
      case 'pwithdata':
        return (
          <P {...childProps} filledFormData={formSubmissionPayload} />
        );
      case 'IconWarning':
        return (
          fieldIndicator
            ? (
              <div
                className={cssProperties.style}
              >
                <IconWarning
                  filled={cssProperties.filled ? cssProperties.filled : ''}
                  title={fieldValue}
                  titleId={fieldValue}
                  size={cssProperties.size}
                  className={cssProperties.iconClass}
                />
              </div>
            ) : null
        );
      case 'IconSuccess':
        return (
          fieldIndicator
            ? (
              <div
                className={cssProperties.style}
              >
                <IconSuccess
                  title={fieldValue}
                  titleId={fieldValue}
                  size={cssProperties.size}
                  className={cssProperties.iconClass}
                />
              </div>
            ) : null
        );
      case 'camera':
        return (
          <div className={cssProperties.style}>
            <Camera />
          </div>
        );
      case 'cameraVideo':
        return (
          <div className={cssProperties.style}>
            <CameraVideo createFile={createFile} />
          </div>
        );
      case 'img':
        return (
          fieldIndicator ? (
            <Image {...childProps} memberInfo={selectedMemberInfo} />
          ) : null
        );
      case 'groupedImg':
        return (
          fieldIndicator ? (
            <GroupedImageSelect
              {...childProps}
              memberInfo={selectedMemberInfo}
              setFormSubmissionPayload={setFormSubmissionPayload}
              formSubmissionPayload={formSubmissionPayload}
            />
          ) : null
        );
      case 'file':
      case 'number':
      case 'email':
      case 'text':
        return (
          <div
            className={cssProperties.style}
          >
            <Input
              {...childProps}
              filledFormData={formSubmissionPayload}
              memberInfo={selectedMemberInfo}
              fileSubmit={fileSubmit}
              handleOnChangeEvents={handleOnChangeEvents}
              setFormSubmissionPayload={setFormSubmissionPayload}
              formSubmissionPayload={formSubmissionPayload}
            />
          </div>
        );
      case 'dlsInput':
        return (
          <div
            className={cssProperties.style}
          >
            <DlsInput
              {...childProps}
              entityCompositeKey={entityCompositeKey}
              loggerApiCall={loggerApiCall}
              entityComments={entityComments}
              comments={comments}
              setComments={setComments}
              idsToClear={idsToClear}
              filledFormData={formSubmissionPayload}
              memberInfo={selectedMemberInfo}
              setValidationErrors={setValidationErrors}
              validationErrors={validationErrors}
              setFocus={setFocus}
              handleOnChangeEvents={handleOnChangeEvents}
              setFormSubmissionPayload={setFormSubmissionPayload}
              formSubmissionPayload={formSubmissionPayload}
              entityToEdit={entityToEdit}
              curPageValues={curPageValues}
              setCurPageValues={setCurPageValues}
              dispatchIdsState={dispatchIdsState}
              extractMapResponseValueByKey={extractMapResponseValueByKey}
              dataObject={{
                memberInfo: selectedMemberInfo,
                formSubmissionPayload,
                curPageValues,
                formContainer,
                entityData,
              }}
              changePageValues={changePageValues}
              setChangePageValues={setChangePageValues}
              journeyId={journeyId}
              iformIntegrationUrls={iformIntegrationUrls}
            />
          </div>
        );
      case 'dlsCarousel':
        return (
          <div
            className={cssProperties.style}
          >
            <DlsCarousel
              {...childProps}
              props={props}
            />
          </div>
        );
      case 'splitInput':
        return (
          <div
            className={cssProperties.style}
          >
            <SplitInput
              {...childProps}
              formSubmissionPayload={formSubmissionPayload}
              setValidationErrors={setValidationErrors}
              validationErrors={validationErrors}
              setFocus={setFocus}
            />
          </div>
        );
      case 'copyLink':
        return (
          <div
            className={cssProperties.style}
          >
            <CopyLink
              {...childProps}
              formSubmissionPayload={formSubmissionPayload}
            />
          </div>
        );
      case 'createQr':
        return (
          <div
            className={cssProperties.style}
          >
            <CreateQr
              {...childProps}
              formSubmissionPayload={formSubmissionPayload}
            />
          </div>
        );
      case 'textArea':
        return (
          <div
            className={cssProperties.style}
          >
            <TextArea
              {...childProps}
              filledFormData={formSubmissionPayload}
              memberInfo={selectedMemberInfo}
              setValidationErrors={setValidationErrors}
              validationErrors={validationErrors}
              setFocus={setFocus}
              curPageValues={curPageValues}
              setCurPageValues={setCurPageValues}
              comments={comments}
              setComments={setComments}
              entityCompositeKey={entityCompositeKey}
              entityComments={entityComments}
              idsToClear={idsToClear}
              entityToEdit={entityToEdit}
            />
          </div>
        );
      case 'groupedAnchor':
        return (
          <GroupedRedirectionAnchor
            {...childProps}
          />
        );
      case 'password':
        return (
          <div
            className={cssProperties.style}
          >
            <Password
              {...childProps}
              setValidationErrors={setValidationErrors}
              validationErrors={validationErrors}
              setFocus={setFocus}
              formSubmissionPayload={formSubmissionPayload}
              setFormSubmissionPayload={setFormSubmissionPayload}
              operationCaller={operationCaller}
              dataObject={{
                memberInfo: selectedMemberInfo,
                formSubmissionPayload,
                curPageValues,
                formContainer,
                entityData,
              }}
            />
          </div>
        );
      case 'select':
        return (
          <Select
            {...childProps}
            handleOnChangeEvents={handleOnChangeEvents}
            filledFormData={formSubmissionPayload}
          />
        );
      case 'dlsSelect':
        return (
          <DlsSelect
            {...childProps}
            comments={comments}
            setComments={setComments}
            handleOnChangeEvents={handleOnChangeEvents}
            filledFormData={formSubmissionPayload}
            setFormSubmissionPayload={setFormSubmissionPayload}
            setValidationErrors={setValidationErrors}
            validationErrors={validationErrors}
            setFocus={setFocus}
            entityToEdit={entityToEdit}
            idsToClear={idsToClear}
            setShowPopUp={setShowPopUp}
            curPageValues={curPageValues}
            setCurPageValues={setCurPageValues}
            formContainer={formContainer}
            formSubmissionPayload={formSubmissionPayload}
            memberInfo={selectedMemberInfo}
            dispatchIdsState={dispatchIdsState}
            objectOfFunctions={objectOfFunctions}
            entityData={entityData}
            changePageValues={changePageValues}
            setChangePageValues={setChangePageValues}
            dataObject={dataObject}
          />
        );
      case 'multiSelect':
        return (
          <MultiSelectComponent
            {...childProps}
            formSubmissionPayload={formSubmissionPayload}
            setFormSubmissionPayload={setFormSubmissionPayload}
            setValidationErrors={setValidationErrors}
            validationErrors={validationErrors}
            setFocus={setFocus}
            idsToClear={idsToClear}
            dispatchIdsState={dispatchIdsState}
            entityToEdit={entityToEdit}
            changePageValues={changePageValues}
            setChangePageValues={setChangePageValues}
          />
        );
      case 'groupedCheckboxes':
        return (
          <GroupedCheckboxes
            {...childProps}
            formSubmissionPayload={formSubmissionPayload}
            setFormSubmissionPayload={setFormSubmissionPayload}
            curPageValues={curPageValues}
            setCurPageValues={setCurPageValues}
            memberInfo={selectedMemberInfo}
            setValidationErrors={setValidationErrors}
            validationErrors={validationErrors}
            setFocus={setFocus}
          />
        );
      case 'popUp':
        return (
          <PopUp
            {...childProps}
            props={props}
            setShowPopUp={setShowPopUp}
            showPopUp={showPopUp}
          />
        );
      case 'checkbox':
        return (
          <Checkbox
            comments={comments}
            setComments={setComments}
            checkConsent={setUserConsentCheckboxValue}
            setFormSubmissionPayload={setFormSubmissionPayload}
            formSubmissionPayload={formSubmissionPayload}
            {...childProps}
            setSelectedOptions={setSelectedOptions}
            selectedOptions={selectedOptions}
            selectedOptionLabels={selectedOptionLabels}
            setSelectedOptionLabels={setSelectedOptionLabels}
            setShowPopUp={setShowPopUp}
            filledFormData={formSubmissionPayload}
            disabledButtons={disabledButtons}
            setDisabledButtons={setDisabledButtons}
            curPageValues={curPageValues}
            setCurPageValues={setCurPageValues}
            dispatchIdsState={dispatchIdsState}
            idsToClear={idsToClear}
          />
        );
      case 'radioButton':
        return (
          <RadioButton
            {...childProps}
            entityCompositeKey={entityCompositeKey}
            entityComments={entityComments}
            entityData={entityData}
            setEntityData={setEntityData}
            entityToEdit={entityToEdit}
            comments={comments}
            setComments={setComments}
            memberInfo={selectedMemberInfo}
            filledFormData={formSubmissionPayload}
            formSubmissionPayload={formSubmissionPayload}
            setFormSubmissionPayload={setFormSubmissionPayload}
            setShowPopUp={setShowPopUp}
            setValidationErrors={setValidationErrors}
            validationErrors={validationErrors}
            setFocus={setFocus}
            idsToClear={idsToClear}
            formContainer={formContainer}
            curPageValues={curPageValues}
            setCurPageValues={setCurPageValues}
            dispatchIdsState={dispatchIdsState}
            changePageValues={changePageValues}
            setChangePageValues={setChangePageValues}
          />
        );
      case 'button':
        return (
          fieldIndicator ? (
            <Button
              {...childProps}
              handleBack={handleBack}
              handleContinue={handleContinue}
              isSubmitButtonDisable={isSubmitButtonDisable}
              isFormSubmission={isFormSubmission}
              setEntityId={setEntityId}
              setFormSubmissionPayload={setFormSubmissionPayload}
              disabledButtons={disabledButtons}
              setShowPopUp={setShowPopUp}
              setEvaluatePopUpId={setEvaluatePopUpId}
              filledFormData={formSubmissionPayload}
              curPageValues={curPageValues}
              dispatchIdsState={dispatchIdsState}
              idsToClear={idsToClear}
            />
          ) : null
        );
      case 'callApiButton':
        return (
          fieldIndicator ? (
            <ApiButton
              {...childProps}
              filledFormData={formSubmissionPayload}
              loggerApiCall={loggerApiCall}
              handleContinue={handleContinue}
              curPageValues={curPageValues}
            />
          ) : null
        );
      case 'currencyInput':
        return (
          fieldIndicator ? (
            <Currency
              {...childProps}
              handleOnChangeEvents={handleOnChangeEvents}
              filledFormData={formSubmissionPayload}
              setCurrencySymbol={setCurrencySymbol}
              setValidationErrors={setValidationErrors}
              validationErrors={validationErrors}
              setFocus={setFocus}
              extractMapResponseValueByKey={extractMapResponseValueByKey}
            />
          ) : null
        );
      case 'list':
        return (
          fieldIndicator ? (
            <List
              {...childProps}
              dataObject={dataObject}
            />
          ) : null
        );
      case 'accordion':
        return (
          <DlsAccordion
            {...childProps}
            className={cssProperties.style}
            handleOnChangeEvents={handleOnChangeEvents}
            memberInfo={selectedMemberInfo}
            formSubmissionPayload={formSubmissionPayload}
            setFormSubmissionPayload={setFormSubmissionPayload}
            isEnableElements={isEnableElements}
          />
        );
      case 'dynamicDlsAccordion':
        return (
          <DynamicDlsAccordion
            {...childProps}
            props={props}
            className={cssProperties.style}
            handleOnChangeEvents={handleOnChangeEvents}
            memberInfo={selectedMemberInfo}
            formSubmissionPayload={formSubmissionPayload}
            setFormSubmissionPayload={setFormSubmissionPayload}
            isEnableElements={isEnableElements}
          />
        );
      case 'dlsTab':
      case 'tabs':
        return (
          <DlsTab
            {...childProps}
            props={props}
            className={cssProperties.style}
            handleOnChangeEvents={handleOnChangeEvents}
            memberInfo={selectedMemberInfo}
            formSubmissionPayload={formSubmissionPayload}
            setFormSubmissionPayload={setFormSubmissionPayload}
            isEnableElements={isEnableElements}
          />
        );
      case 'actionableCard':
        return (
          <ActionableCard
            {...childProps}
            props={props}
          />
        );
      case 'table':
        return (
          <div className={cssProperties.style}>
            <table className={`table ${fieldLabel.cssProperties.style}`}>
              <thead>
                <tr>
                  {
                    fieldLabel.tableData.map((cell) => (
                      <>
                        {
                          cell.th.map((value) => (
                            <th key={value} className="text-align-center" style={{ textTransform: 'capitalize' }}>{value}</th>
                          ))
                        }
                      </>
                    ))
                  }
                </tr>
              </thead>
              <tbody>
                {
                  fieldLabel.tableData.map((cell) => cell.tr && cell.tr.map((value) => (
                    <tr key={value}>{value}</tr>
                  ))
                  )
                }
              </tbody>
            </table>
          </div>
        );
      case 'fileUpload':
        return (
          <FileUpload
            loggerApiCall={loggerApiCall}
            getFileUploadInfo={getFileUploadInfo}
            objectOfFunctions={objectOfFunctions}
            formSubmissionPayload={formSubmissionPayload}
            journeyId={journeyId}
            filledFormData={formSubmissionPayload}
            griffinFileInfo={griffinFileInfo}
            setGriffinFileInfo={setGriffinFileInfo}
            formPageType={formPageType}
            disabledButtons={disabledButtons}
            setDisabledButtons={setDisabledButtons}
            {...childProps}
          />
        );
      case 'attachFilesToPayload':
        return (
          <PayloadFileAttachment
            loggerApiCall={loggerApiCall}
            entityToEdit={entityToEdit}
            journeyId={journeyId}
            filledFormData={formSubmissionPayload}
            filesToAttach={filesToAttach}
            setFilesToAttach={setFilesToAttach}
            s3FileInfo={s3FileInfo}
            setS3FileInfo={setS3FileInfo}
            formPageType={formPageType}
            allS3FileIds={allS3FileIds}
            setAllS3FileIds={setAllS3FileIds}
            disabledButtons={disabledButtons}
            setDisabledButtons={setDisabledButtons}
            {...childProps}
          />
        );

      case 'attachFilesToPayloadV2':
        return (
          <PayloadFileAttachmentV2
            loggerApiCall={loggerApiCall}
            entityToEdit={entityToEdit}
            journeyId={journeyId}
            filledFormData={formSubmissionPayload}
            filesToAttach={filesToAttach}
            setFilesToAttach={setFilesToAttach}
            s3FileInfo={s3FileInfo}
            setS3FileInfo={setS3FileInfo}
            formPageType={formPageType}
            allS3FileIds={allS3FileIds}
            setAllS3FileIds={setAllS3FileIds}
            disabledButtons={disabledButtons}
            setDisabledButtons={setDisabledButtons}
            comments={comments}
            setComments={setComments}
            {...childProps}

          />

        );
      case 'modal':
        return (<Modal {...childProps} />);
      case 'hr':
        return (<hr className={cssProperties.style} />);
      case 'badge':
        return (<span className="badge badge-outline filled">All</span>);
      case 'hrWithWord':
        return (
          <div
            className={cssProperties.style}
            style={{
              width: '100%', height: '12px', borderBottom: '1px solid black', textAlign: 'center',
            }}
          >
            <span style={{ fontSize: '22px', backgroundColor: '#FFF', padding: '0 10px' }}>
              OR
            </span>
          </div>
        );
      case 'datePicker':
        return (
          <DateSelector
            setValidationErrors={setValidationErrors}
            validationErrors={validationErrors}
            setFocus={setFocus}
            formSubmissionPayload={formSubmissionPayload}
            setFormSubmissionPayload={setFormSubmissionPayload}
            idsToClear={idsToClear}
            entityToEdit={entityToEdit}
            curPageValues={curPageValues}
            setCurPageValues={setCurPageValues}
            changePageValues={changePageValues}
            setChangePageValues={setChangePageValues}
            dispatchIdsState={dispatchIdsState}
            dataObject={{
              memberInfo: selectedMemberInfo, formSubmissionPayload, curPageValues, formContainer,
            }}
            {...childProps}
          />
        );
      case 'dateRangePicker':
        return (
          <DlsDateRangePicker
            setValidationErrors={setValidationErrors}
            validationErrors={validationErrors}
            setFocus={setFocus}
            formSubmissionPayload={formSubmissionPayload}
            {...childProps}
          />
        );
      case 'dateInput':
        return (
          <InputDate
            {...childProps}
            setValidationErrors={setValidationErrors}
            validationErrors={validationErrors}
            setFocus={setFocus}
            filledFormData={formSubmissionPayload}
            setFormSubmissionPayload={setFormSubmissionPayload}
            idsToClear={idsToClear}
            comments={comments}
            setComments={setComments}
            entityToEdit={entityToEdit}
            entityCompositeKey={entityCompositeKey}
            entityComments={entityComments}
          />
        );
      case 'consent':
        return (
          <Consent
            {...childProps}
            handleSubmit={handleSubmit}
            fileUploadInfo={fileUploadInfo}
            isFormSubmission={isFormSubmission}
            formSubmissionPayload={formSubmissionPayload}
          />
        );
      case 'requestLimit':
        return (
          <RequestLimit
            {...childProps}
            setCurrencySymbol={setCurrencySymbol}
          />
        );
      case 'multitracker':
        return (
          <MultiTracker {...childProps} />
        );
      case 'banner':
        return (
          <HeroBanner {...childProps} />
        );
      case 'customTag':
        switch (customTag.tagName) {
          case 'eSign': {
            return (
              <Esign
                elementContainer={elementContainer}
                formSubmissionPayload={formSubmissionPayload}
                selectedMemberInfo={selectedMemberInfo}
                childProps={childProps}
                formContainer={formContainer}
                loggerApiCall={loggerApiCall}
                handleContinue={handleContinue}
                putDataToS3={putDataToS3}
                s3EsignFileInfo={s3EsignFileInfo}
                setFormSubmissionPayload={setFormSubmissionPayload}
                journeyId={journeyId}
                payloadFields={payloadFields}
                setFileData={setFileData}
                objectOfFunctions={objectOfFunctions}
                apiResponse={apiResponse}
                setApiResponse={setApiResponse}
                setS3FileInfo={setS3FileInfo}
                s3FileInfo={s3FileInfo}
                setAllS3FileIds={setAllS3FileIds}
                setS3EsignFileInfo={setS3EsignFileInfo}
                setIsFormSubmission={setIsFormSubmission}
              />
            );
          }
          case 'singpass': {
            return (
              <Singpass
                childProps={childProps}
                formSubmissionPayload={formSubmissionPayload}
                setFormSubmissionPayload={setFormSubmissionPayload}
                journeyId={journeyId}
                handleContinue={handleContinue}
              />
            );
          }
          default:
            return null;
        }
      case 'cardSelection':
        return <CardSelection {...childProps} handleOnChangeEvents={handleOnChangeEvents} />;
      case 'cardPayment':
        return (
          <CardPayment
            filledFormData={formSubmissionPayload}
            handleOnChangeEvents={handleOnChangeEvents}
            {...childProps}
            setFormSubmissionPayload={setFormSubmissionPayload}
            formSubmissionPayload={formSubmissionPayload}
          />
        );
      case 'iconWithLabel':
        return (
          <IconWithLabel
            {...childProps}
            filledFormData={formSubmissionPayload}
          />
        );
      case 'statictable':
        return (
          <StaticTable
            filledFormData={formSubmissionPayload}
            setFormSubmissionPayload={setFormSubmissionPayload}
            memberInfo={selectedMemberInfo}
            entityData={entityData}
            objectOfFunctions={objectOfFunctions}
            {...childProps}
          />
        );
      case 'expandableTable':
        return (
          <ExpandableTable
            comments={comments}
            setComments={setComments}
            entityComments={entityComments}
            setEntityCompositeKey={setEntityCompositeKey}
            formSubmissionPayload={formSubmissionPayload}
            setFormSubmissionPayload={setFormSubmissionPayload}
            memberInfo={selectedMemberInfo}
            entityData={entityData}
            operationCaller={operationCaller}
            extractMapResponseValueByKey={extractMapResponseValueByKey}
            {...childProps}
          />
        );
      case 'cardDetails':
        return (
          <CardDetails
            {...childProps}
            setFormSubmissionPayload={setFormSubmissionPayload}
            formSubmissionPayload={formSubmissionPayload}
            setValidationErrors={setValidationErrors}
            validationErrors={validationErrors}

          />
        );
      case 'showSubKeys':
        return (
          <ShowSubKeys {...childProps} filledFormData={formSubmissionPayload} />
        );
      case 'reCaptcha':
        return (
          <ReCaptcha {...childProps} />
        );
      case 'search':
        return (
          <Search
            {...childProps}
            setFormSubmissionPayload={setFormSubmissionPayload}
            formSubmissionPayload={formSubmissionPayload}
          />
        );
      case 'mapsdisplay':
        return (
          <Maps
            {...childProps}
            setFormSubmissionPayload={setFormSubmissionPayload}
            formSubmissionPayload={formSubmissionPayload}
          />
        );
      case 'anchorwithpopup':
        return (
          <Anchor
            {...childProps}
            setShowPopUp={setShowPopUp}
          />

        );
      case 'phoneNumber':
        return (
          <Phone
            {...childProps}
            setValidationErrors={setValidationErrors}
            validationErrors={validationErrors}
            formSubmissionPayload={formSubmissionPayload}
          />

        );
      case 'showsupp':
        return (
          <SuppCardComponent
            {...childProps}
            memberInfo={selectedMemberInfo}
            filledFormData={formSubmissionPayload}
            setFormSubmissionPayload={setFormSubmissionPayload}
            formSubmissionPayload={formSubmissionPayload}
            handleContinue={handleContinue}
            curPageValues={curPageValues}
            disabledButtons={disabledButtons}
            setFocus={setFocus}
            setDisabledButtons={setDisabledButtons}
          />

        );
      case 'showsuppDetails':
        return (
          <SuppCardDetails
            {...childProps}
            setFormSubmissionPayload={setFormSubmissionPayload}
            formSubmissionPayload={formSubmissionPayload}
          />
        );
      default:
        return null;
    }
  };
  /* eslint-enable  import/no-cycle -- need */
  return (
    <>
      {elementSwitch(fieldType)}
    </>
  );
};

export default findElement;
